module.exports = __webpack_public_path__ + "static/media/dontcopy5.e77164b4.gif";